document.addEventListener("DOMContentLoaded", function() {
  const CONFIG = window.SPACTIFY_CONFIG || {};
  const API_PREFIX = CONFIG.apiPrefix || "/apps/spactify";
  const STAGE_ORDER = ["analyzing", "recommending", "generating", "done"];
  const GENERATION_EXPECTED_MS = 40000;
  const GENERATION_FAST_PHASE_MS = GENERATION_EXPECTED_MS * 0.3;
  const SHOWCASE_FEED_URL = String(CONFIG.showcaseFeedUrl || "https://audit.spactify.com/api/v1/remodel-showcase").trim();
  const SHOWCASE_CYCLE_MS = 10000;
  const SHOWCASE_TRAVEL_MS = 4000;
  const SHOWCASE_HOLD_MS = 1000;
  const SHOWCASE_TRANSITION_MS = 90;
  const SHOWCASE_MANUAL_PAUSE_MS = 1500;
  const SHOWCASE_RESUME_BLEND_MS = 250;
  const GA_MEASUREMENT_ID = String(window.SPACTIFY_GA_MEASUREMENT_ID || CONFIG.gaMeasurementId || "").trim();
  const GA_DEBUG_MODE = window.SPACTIFY_GA_DEBUG_MODE === undefined
    ? Boolean(CONFIG.gaDebugMode)
    : Boolean(window.SPACTIFY_GA_DEBUG_MODE);
  const GA_GET_TIMEOUT_MS = 1200;
  const REMODEL_DB_NAME = "spactify-remodel";
  const REMODEL_DB_VERSION = 1;
  const UPLOAD_RETENTION_MS = 7 * 24 * 60 * 60 * 1000;
  const MAX_LOCAL_UPLOADS = 3;
  const MAX_LOCAL_UPLOAD_BYTES = 50 * 1024 * 1024;

  const dropZone = document.getElementById("drop-zone");
  const fileInput = document.getElementById("file-input");
  const browseBtn = document.getElementById("browse-btn");
  const uploadPlaceholder = document.getElementById("upload-placeholder-content");
  const previewContainer = document.getElementById("preview-container");
  const roomPreviewImg = document.getElementById("room-preview-img");
  const removeImgBtn = document.getElementById("remove-img-btn");
  const styleGrid = document.getElementById("style-grid");
  const styleCards = Array.from(document.querySelectorAll(".spactify-style-card"));
  const generateBtn = document.getElementById("generate-btn");
  const outputSection = document.getElementById("output-section");
  const progressPanel = document.getElementById("progress-panel");
  const progressSteps = Array.from(document.querySelectorAll(".spactify-progress-step"));
  const progressError = document.getElementById("progress-error");
  const generationFeedback = document.getElementById("generation-feedback");
  const generationMeter = document.getElementById("generation-meter");
  const generationMeterFill = document.getElementById("generation-meter-fill");
  const generationPercent = document.getElementById("generation-percent");
  const generationStatus = document.getElementById("generation-status");
  const waitingShowcase = document.getElementById("waiting-showcase");
  const waitingComparison = document.getElementById("waiting-comparison");
  const waitingBeforeImg = document.getElementById("waiting-before-img");
  const waitingAfterImg = document.getElementById("waiting-after-img");
  const waitingSlider = document.getElementById("waiting-slider");
  const recommendationPanel = document.getElementById("recommendation-panel");
  const previewProductsList = document.getElementById("preview-products-list");
  const previewProductCount = document.getElementById("preview-product-count");
  const recommendationAnalysis = document.getElementById("recommendation-analysis");
  const generateFinalBtn = document.getElementById("generate-final-btn");
  const resultPanel = document.getElementById("result-panel");
  const afterPanel = document.getElementById("after-panel");
  const resultAfterImg = document.getElementById("result-after-img");
  const resultBeforeImg = document.getElementById("result-before-img");
  const comparisonPanel = document.getElementById("comparison-panel");
  const comparisonSlider = document.getElementById("comparison-slider");
  const productsPanel = document.getElementById("products-panel");
  const productsList = document.getElementById("recommended-products-list");
  const productCount = document.getElementById("product-count");
  const previewAddToCartBtn = document.getElementById("preview-add-to-cart-btn");
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const addToCartButtons = [previewAddToCartBtn, addToCartBtn].filter(Boolean);
  const downloadRemodelBtn = document.getElementById("download-remodel-btn");

  let uploadedFile = null;
  let uploadedPreviewUrl = "";
  let uploadedPreviewObjectUrl = "";
  let currentUploadId = "";
  let currentRunId = createFlowId();
  let remodelDbPromise = null;
  let selectedStyle = "北歐風 Nordic Style";
  let pollTimer = null;
  let pollRequestController = null;
  let pollConsecutiveFailures = 0;
  let pollPausedForNavigation = false;
  let generatedProducts = [];
  const selectedCartVariantIds = new Set();
  let preparedResult = null;
  let currentCacheKey = "";
  let currentTaskId = "";
  let isPreparing = false;
  let isGenerating = false;
  let stageSyncFrame = null;
  let generationProgressTimer = null;
  let generationStartedAt = null;
  let generationLastPercent = 0;
  let currentProgressIndex = 0;
  let showcaseCases = null;
  let showcaseQueue = [];
  let showcaseQueueIndex = 0;
  let showcaseActiveCase = null;
  let showcaseCycleStartedAt = 0;
  let showcaseAnimationFrame = null;
  let showcaseRunning = false;
  let showcasePointerActive = false;
  let showcaseManualResumeAt = 0;
  let showcaseResumeBlendStartedAt = null;
  let showcaseResumeBlendFrom = 0;
  let showcaseCurrentPosition = 0;
  let showcaseDragTracked = false;
  let showcaseLoadSequence = 0;
  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  let activeGenerateStartedAt = null;
  let currentFlowId = createFlowId();
  let gtagBootstrapped = false;

  function createFlowId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return `flow_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  function openRemodelDatabase() {
    if (!window.indexedDB) {
      return Promise.reject(new Error("此瀏覽器不支援 IndexedDB。"));
    }
    if (remodelDbPromise) return remodelDbPromise;

    remodelDbPromise = new Promise(function(resolve, reject) {
      const request = window.indexedDB.open(REMODEL_DB_NAME, REMODEL_DB_VERSION);
      request.onupgradeneeded = function() {
        const db = request.result;
        if (!db.objectStoreNames.contains("uploads")) {
          const uploads = db.createObjectStore("uploads", { keyPath: "id" });
          uploads.createIndex("createdAt", "createdAt");
        }
        if (!db.objectStoreNames.contains("runs")) {
          const runs = db.createObjectStore("runs", { keyPath: "id" });
          runs.createIndex("updatedAt", "updatedAt");
          runs.createIndex("status", "status");
        }
      };
      request.onsuccess = function() {
        const db = request.result;
        db.onversionchange = function() {
          db.close();
          remodelDbPromise = null;
        };
        resolve(db);
      };
      request.onerror = function() {
        remodelDbPromise = null;
        reject(request.error || new Error("無法開啟 IndexedDB。"));
      };
      request.onblocked = function() {
        remodelDbPromise = null;
        reject(new Error("IndexedDB 升級被其他分頁阻擋。"));
      };
    });

    return remodelDbPromise;
  }

  function runIndexedDbRequest(storeName, mode, operation) {
    return openRemodelDatabase().then(function(db) {
      return new Promise(function(resolve, reject) {
        const transaction = db.transaction(storeName, mode);
        const store = transaction.objectStore(storeName);
        let request;
        try {
          request = operation(store);
        } catch (error) {
          reject(error);
          return;
        }
        transaction.oncomplete = function() {
          resolve(request ? request.result : undefined);
        };
        transaction.onerror = function() {
          reject(transaction.error || (request && request.error) || new Error("IndexedDB 操作失敗。"));
        };
        transaction.onabort = function() {
          reject(transaction.error || new Error("IndexedDB 操作已取消。"));
        };
      });
    });
  }

  function putIndexedDbRecord(storeName, record) {
    return runIndexedDbRequest(storeName, "readwrite", function(store) {
      return store.put(record);
    });
  }

  function getIndexedDbRecord(storeName, id) {
    if (!id) return Promise.resolve(null);
    return runIndexedDbRequest(storeName, "readonly", function(store) {
      return store.get(id);
    }).then(function(record) {
      return record || null;
    });
  }

  function deleteIndexedDbRecord(storeName, id) {
    if (!id) return Promise.resolve();
    return runIndexedDbRequest(storeName, "readwrite", function(store) {
      return store.delete(id);
    });
  }

  function getAllIndexedDbRecords(storeName) {
    return runIndexedDbRequest(storeName, "readonly", function(store) {
      return store.getAll();
    });
  }

  function pruneStoredUploads(activeUploadId) {
    return getAllIndexedDbRecords("uploads").then(function(records) {
      const now = Date.now();
      const sorted = records.slice().sort(function(a, b) {
        return Number(b.lastAccessedAt || b.createdAt || 0) - Number(a.lastAccessedAt || a.createdAt || 0);
      });
      let retainedCount = 0;
      let retainedBytes = 0;
      const removals = [];

      sorted.forEach(function(record) {
        const recordSize = Number(record.size || (record.blob && record.blob.size) || 0);
        const expired = now - Number(record.lastAccessedAt || record.createdAt || now) > UPLOAD_RETENTION_MS;
        const overLimit = retainedCount >= MAX_LOCAL_UPLOADS || retainedBytes + recordSize > MAX_LOCAL_UPLOAD_BYTES;
        if (record.id !== activeUploadId && (expired || overLimit)) {
          removals.push(deleteIndexedDbRecord("uploads", record.id));
          return;
        }
        retainedCount += 1;
        retainedBytes += recordSize;
      });

      return Promise.all(removals);
    });
  }

  function storeUploadedFile(file, uploadId) {
    const now = Date.now();
    return putIndexedDbRecord("uploads", {
      id: uploadId,
      blob: file,
      fileName: file.name || "room-image",
      mimeType: file.type || "application/octet-stream",
      size: Number(file.size || 0),
      lastModified: Number(file.lastModified || now),
      createdAt: now,
      lastAccessedAt: now
    }).then(function() {
      return pruneStoredUploads(uploadId);
    });
  }

  function hasConfiguredGaMeasurementId() {
    return /^G-[A-Z0-9]+$/i.test(GA_MEASUREMENT_ID) && GA_MEASUREMENT_ID !== "G-XXXXXXXXXX";
  }

  function ensureGtag() {
    if (typeof window.gtag === "function") {
      return true;
    }

    if (!hasConfiguredGaMeasurementId()) {
      return false;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };

    if (!document.querySelector(`script[src*="gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
      document.head.appendChild(script);
    }

    if (!gtagBootstrapped) {
      window.gtag("js", new Date());
      window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
      gtagBootstrapped = true;
    }

    return true;
  }

  function getStoreCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "TWD";
  }

  function buildSkuList(products) {
    return products
      .map(function(product) {
        return product.sku || product.product_id || "";
      })
      .filter(Boolean)
      .slice(0, 10)
      .join(",");
  }

  function buildAnalyticsItems(products) {
    return products.map(function(product, index) {
      const price = Number(product.price);
      const item = {
        item_id: product.sku || product.product_id || product.handle || `spactify_item_${index + 1}`,
        item_name: product.title || product.handle || "Spactify recommended product",
        item_category: product.category || "",
        item_list_id: "spactify_recommendations",
        item_list_name: "Spactify recommendations",
        quantity: 1,
        index: index
      };

      if (Number.isFinite(price)) {
        item.price = price;
      }
      if (product.variant_id) {
        item.item_variant = String(product.variant_id);
      }

      return item;
    });
  }

  function calculateProductsValue(products) {
    return products.reduce(function(total, product) {
      const price = Number(product.price);
      return Number.isFinite(price) ? total + price : total;
    }, 0);
  }

  function trackSpactifyEvent(eventName, params, options) {
    const eventParams = Object.assign({
      event_category: "spactify_remodel",
      flow_id: currentFlowId,
      page_path: window.location.pathname
    }, params || {});

    if (GA_DEBUG_MODE) {
      eventParams.debug_mode = true;
    }

    if (!ensureGtag()) {
      return Promise.resolve(false);
    }

    return new Promise(function(resolve) {
      let settled = false;
      const waitForCallback = options && options.waitForCallback;
      const finish = function(value) {
        if (settled) return;
        settled = true;
        resolve(value);
      };

      if (waitForCallback) {
        eventParams.event_callback = function() {
          finish(true);
        };
        eventParams.event_timeout = options.eventTimeout || 800;
        window.setTimeout(function() {
          finish(false);
        }, eventParams.event_timeout);
      }

      try {
        window.gtag("event", eventName, eventParams);
        if (!waitForCallback) {
          finish(true);
        }
      } catch (error) {
        console.warn("Spactify GA event failed", eventName, error);
        finish(false);
      }
    });
  }

  function getGtagField(fieldName) {
    if (!hasConfiguredGaMeasurementId() || !ensureGtag()) {
      return Promise.resolve("");
    }

    return new Promise(function(resolve) {
      let settled = false;
      const finish = function(value) {
        if (settled) return;
        settled = true;
        resolve(value == null ? "" : String(value));
      };

      window.setTimeout(function() {
        finish("");
      }, GA_GET_TIMEOUT_MS);

      try {
        window.gtag("get", GA_MEASUREMENT_ID, fieldName, finish);
      } catch (error) {
        console.warn("Spactify GA field lookup failed", fieldName, error);
        finish("");
      }
    });
  }

  function getGaIdentifiers() {
    return Promise.all([
      getGtagField("client_id"),
      getGtagField("session_id"),
      getGtagField("session_number")
    ]).then(function(values) {
      return {
        clientId: values[0],
        sessionId: values[1],
        sessionNumber: values[2]
      };
    });
  }

  function withApiPrefix(path) {
    if (!path) return "";
    if (/^(https?:|data:|blob:|\/\/)/.test(path)) return path;
    return `${API_PREFIX}${path.charAt(0) === "/" ? path : `/${path}`}`;
  }

  function getStoredLifecycleState() {
    try {
      return JSON.parse(window.sessionStorage.getItem("spactifyRemodelState") || "null");
    } catch (error) {
      return null;
    }
  }

  function buildLifecycleSnapshot(result) {
    if (!result) return null;
    return {
      status: result.status || "",
      stage: result.stage || "",
      cache_key: result.cache_key || currentCacheKey,
      task_id: result.task_id || currentTaskId,
      style: result.style || selectedStyle,
      image_url: result.image_url || "",
      output_width: result.output_width || null,
      output_height: result.output_height || null,
      analysis: result.analysis || "",
      products: result.products || generatedProducts
    };
  }

  function persistLifecycleState(extra) {
    const payload = Object.assign({
      runId: currentRunId,
      uploadId: currentUploadId,
      cacheKey: currentCacheKey,
      taskId: currentTaskId,
      style: selectedStyle,
      status: preparedResult && preparedResult.status,
      products: preparedResult && preparedResult.products ? preparedResult.products : generatedProducts,
      snapshot: buildLifecycleSnapshot(preparedResult)
    }, extra || {});

    try {
      window.sessionStorage.setItem("spactifyRemodelState", JSON.stringify(payload));
      window.sessionStorage.setItem("spactifyActiveRunId", currentRunId);
    } catch (error) {
      // Storage can be unavailable in private browsing.
    }

    putIndexedDbRecord("runs", Object.assign({
      id: currentRunId,
      updatedAt: Date.now()
    }, payload)).catch(function(error) {
      console.warn("無法保存 IndexedDB 任務快照。", error);
    });
  }

  function clearLifecycleState() {
    currentCacheKey = "";
    currentTaskId = "";
    preparedResult = null;
    try {
      window.sessionStorage.removeItem("spactifyRemodelState");
    } catch (error) {
      // Ignore storage cleanup failures.
    }
  }

  function setGenerateState() {
    generateBtn.disabled = isPreparing || isGenerating || !uploadedFile || !selectedStyle;
    if (isPreparing) {
      generateBtn.textContent = "搭配商品中...";
    } else if (isGenerating) {
      generateBtn.textContent = "改造圖產生中...";
    } else {
      generateBtn.textContent = "✨ 開始改造";
    }
    if (generateFinalBtn) {
      generateFinalBtn.disabled = isGenerating || !currentCacheKey || !uploadedFile;
      generateFinalBtn.textContent = isGenerating
        ? "改造圖產生中..."
        : !uploadedFile && currentCacheKey
          ? "請重新上傳照片"
          : "產生最終改造圖";
    }
    updateCartButtonState();
  }

  function updateCartButtonState() {
    const canAddToCart = generatedProducts.some(function(product) {
      return product.variant_id;
    });
    const hasSelectedProducts = generatedProducts.some(function(product) {
      return product.variant_id && selectedCartVariantIds.has(String(product.variant_id));
    });
    addToCartButtons.forEach(function(button) {
      button.disabled = !canAddToCart;
      if (button.dataset.loading !== "true") {
        button.textContent = hasSelectedProducts
          ? "指定加入購物車"
          : "全部放入購物車";
      }
    });
  }

  function setComparisonPosition(value) {
    const numericValue = Number(value);
    const clampedValue = Number.isFinite(numericValue)
      ? Math.min(100, Math.max(0, numericValue))
      : 50;
    if (comparisonPanel) {
      comparisonPanel.style.setProperty("--spactify-compare-position", `${clampedValue}%`);
    }
    if (comparisonSlider && comparisonSlider.value !== String(clampedValue)) {
      comparisonSlider.value = String(clampedValue);
    }
  }

  function resetResultDisplay() {
    if (resultBeforeImg) {
      resultBeforeImg.src = "";
      resultBeforeImg.hidden = true;
    }
    if (resultAfterImg) {
      resultAfterImg.src = "";
      resultAfterImg.removeAttribute("width");
      resultAfterImg.removeAttribute("height");
    }
    if (comparisonPanel) {
      comparisonPanel.dataset.mode = "after-only";
    }
    if (comparisonSlider) {
      comparisonSlider.hidden = true;
      comparisonSlider.disabled = true;
    }
    setComparisonPosition(50);
  }

  function renderResultComparison(afterImageUrl) {
    const beforeImageUrl = uploadedPreviewUrl;
    resultAfterImg.src = afterImageUrl;

    if (beforeImageUrl && resultBeforeImg && comparisonPanel && comparisonSlider) {
      resultBeforeImg.src = beforeImageUrl;
      resultBeforeImg.hidden = false;
      comparisonPanel.dataset.mode = "compare";
      comparisonSlider.hidden = false;
      comparisonSlider.disabled = false;
      setComparisonPosition(comparisonSlider.value || 50);
      return;
    }

    if (resultBeforeImg) {
      resultBeforeImg.src = "";
      resultBeforeImg.hidden = true;
    }
    if (comparisonPanel) {
      comparisonPanel.dataset.mode = "after-only";
    }
    if (comparisonSlider) {
      comparisonSlider.hidden = true;
      comparisonSlider.disabled = true;
    }
    setComparisonPosition(50);
  }

  function hideRecommendationPanel() {
    if (recommendationPanel) {
      recommendationPanel.hidden = true;
    }
  }

  function showResultShell(showProducts) {
    outputSection.hidden = false;
    hideRecommendationPanel();
    resultPanel.hidden = false;
    if (productsPanel) {
      productsPanel.hidden = !showProducts;
    }
  }

  function syncUploadStageHeight() {
    stageSyncFrame = null;
    if (!styleGrid || !dropZone) return;

    if (window.matchMedia("(max-width: 980px)").matches) {
      dropZone.style.removeProperty("--spactify-input-stage-height");
      return;
    }

    const styleHeight = styleGrid.getBoundingClientRect().height;
    if (styleHeight > 0) {
      dropZone.style.setProperty("--spactify-input-stage-height", `${Math.round(styleHeight)}px`);
    }
  }

  function requestStageSync() {
    if (stageSyncFrame) {
      window.cancelAnimationFrame(stageSyncFrame);
    }
    stageSyncFrame = window.requestAnimationFrame(syncUploadStageHeight);
  }

  requestStageSync();

  window.addEventListener("resize", requestStageSync);

  if ("ResizeObserver" in window) {
    const styleGridObserver = new ResizeObserver(requestStageSync);
    styleGridObserver.observe(styleGrid);
  }

  styleCards.forEach(function(card) {
    const image = card.querySelector("img");
    if (image && !image.complete) {
      image.addEventListener("load", requestStageSync, { once: true });
    }
  });

  function formatGenerationDuration(milliseconds) {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = String(totalSeconds % 60).padStart(2, "0");

    return `${minutes}:${seconds}`;
  }

  function clearGenerationProgressTimer() {
    if (generationProgressTimer) {
      clearInterval(generationProgressTimer);
      generationProgressTimer = null;
    }
  }

  function setGenerationProgressValue(percent) {
    const clampedPercent = Math.min(100, Math.max(0, percent));
    const roundedPercent = Math.round(clampedPercent);
    generationLastPercent = clampedPercent;
    generationMeterFill.style.width = `${clampedPercent}%`;
    generationMeter.setAttribute("aria-valuenow", String(roundedPercent));
    generationPercent.textContent = `${roundedPercent}%`;
  }

  function updateGenerationProgress() {
    if (!generationStartedAt) return;

    const elapsedMs = Date.now() - generationStartedAt;
    const overtimeMs = Math.max(0, elapsedMs - GENERATION_EXPECTED_MS);
    const slowPhaseMs = GENERATION_EXPECTED_MS - GENERATION_FAST_PHASE_MS;
    const estimatedPercent = elapsedMs <= GENERATION_FAST_PHASE_MS
      ? 8 + (elapsedMs / GENERATION_FAST_PHASE_MS) * 72
      : elapsedMs < GENERATION_EXPECTED_MS
        ? 80 + ((elapsedMs - GENERATION_FAST_PHASE_MS) / slowPhaseMs) * 18
        : 98;
    const nextPercent = Math.max(generationLastPercent, estimatedPercent);
    const elapsedText = formatGenerationDuration(elapsedMs);
    const statusText = overtimeMs > 0
      ? `比預期的還要久，努力趕工中。請再稍等片刻。已等待 ${elapsedText}。`
      : `預估約 40 秒，已等待 ${elapsedText}。正在細修光線與家具比例。`;

    setGenerationProgressValue(nextPercent);
    generationStatus.textContent = statusText;
    generationMeter.setAttribute("aria-valuetext", statusText);
  }

  function startGenerationProgress() {
    generationFeedback.setAttribute("aria-hidden", "false");

    if (!generationStartedAt) {
      generationStartedAt = Date.now();
      generationLastPercent = 0;
      setGenerationProgressValue(8);
      updateGenerationProgress();
    }

    if (!generationProgressTimer) {
      generationProgressTimer = setInterval(updateGenerationProgress, 1000);
    }
  }

  function completeGenerationProgress() {
    clearGenerationProgressTimer();
    generationStartedAt = null;
    progressPanel.dataset.stage = "done";
    generationFeedback.setAttribute("aria-hidden", "false");
    setGenerationProgressValue(100);
    generationStatus.textContent = "改造圖完成，正在整理結果。";
    generationMeter.setAttribute("aria-valuetext", generationStatus.textContent);
  }

  function resetGenerationProgress() {
    clearGenerationProgressTimer();
    generationStartedAt = null;
    generationLastPercent = 0;
    setGenerationProgressValue(0);
    progressPanel.removeAttribute("data-stage");
    generationFeedback.setAttribute("aria-hidden", "true");
    generationStatus.textContent = "";
    generationMeter.removeAttribute("aria-valuetext");
  }

  function setWaitingShowcasePosition(value) {
    const numericValue = Number(value);
    const clampedValue = Number.isFinite(numericValue)
      ? Math.min(100, Math.max(0, numericValue))
      : 0;
    showcaseCurrentPosition = clampedValue;
    waitingComparison.style.setProperty("--spactify-waiting-position", `${clampedValue}%`);
    if (waitingSlider.value !== String(Math.round(clampedValue))) {
      waitingSlider.value = String(Math.round(clampedValue));
    }
  }

  function shuffleShowcaseCases(cases, previousRunId) {
    const shuffled = cases.slice();
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      const current = shuffled[index];
      shuffled[index] = shuffled[swapIndex];
      shuffled[swapIndex] = current;
    }
    if (shuffled.length > 1 && shuffled[0].run_id === previousRunId) {
      const replacementIndex = shuffled.findIndex(function(item) {
        return item.run_id !== previousRunId;
      });
      const first = shuffled[0];
      shuffled[0] = shuffled[replacementIndex];
      shuffled[replacementIndex] = first;
    }
    return shuffled;
  }

  function resolveShowcaseAssetUrl(path) {
    if (!path) return "";
    try {
      return new URL(path, SHOWCASE_FEED_URL).href;
    } catch (error) {
      return path;
    }
  }

  function preloadShowcaseCase(item) {
    const beforeUrl = resolveShowcaseAssetUrl(item.before_url);
    const afterUrl = resolveShowcaseAssetUrl(item.after_url);
    if (!beforeUrl || !afterUrl) return Promise.reject(new Error("missing_showcase_media"));

    return Promise.all([beforeUrl, afterUrl].map(function(url) {
      return new Promise(function(resolve, reject) {
        const image = new Image();
        image.onload = function() { resolve(url); };
        image.onerror = function() { reject(new Error("showcase_image_load_failed")); };
        image.src = url;
      });
    })).then(function(urls) {
      return Object.assign({}, item, {
        resolvedBeforeUrl: urls[0],
        resolvedAfterUrl: urls[1]
      });
    });
  }

  function nextShowcaseCandidate() {
    if (!showcaseCases || !showcaseCases.length) return null;
    if (showcaseQueueIndex >= showcaseQueue.length) {
      showcaseQueue = shuffleShowcaseCases(
        showcaseCases,
        showcaseActiveCase && showcaseActiveCase.run_id
      );
      showcaseQueueIndex = 0;
    }
    const candidate = showcaseQueue[showcaseQueueIndex];
    showcaseQueueIndex += 1;
    return candidate;
  }

  function showcaseTargetPosition(elapsedMs) {
    if (elapsedMs < SHOWCASE_TRAVEL_MS) {
      return (elapsedMs / SHOWCASE_TRAVEL_MS) * 100;
    }
    if (elapsedMs < SHOWCASE_TRAVEL_MS + SHOWCASE_HOLD_MS) {
      return 100;
    }
    if (elapsedMs < SHOWCASE_TRAVEL_MS * 2 + SHOWCASE_HOLD_MS) {
      return 100 - ((elapsedMs - SHOWCASE_TRAVEL_MS - SHOWCASE_HOLD_MS) / SHOWCASE_TRAVEL_MS) * 100;
    }
    return 0;
  }

  function tickWaitingShowcase(now) {
    if (!showcaseRunning || reduceMotionQuery.matches || !showcaseActiveCase) return;
    const elapsedMs = now - showcaseCycleStartedAt;
    if (elapsedMs >= SHOWCASE_CYCLE_MS) {
      showNextWaitingCase();
      return;
    }

    if (showcasePointerActive || now < showcaseManualResumeAt) {
      showcaseAnimationFrame = window.requestAnimationFrame(tickWaitingShowcase);
      return;
    }

    const targetPosition = showcaseTargetPosition(elapsedMs);
    if (showcaseResumeBlendStartedAt === null && showcaseManualResumeAt > 0) {
      showcaseResumeBlendStartedAt = now;
      showcaseResumeBlendFrom = showcaseCurrentPosition;
    }
    if (showcaseResumeBlendStartedAt !== null) {
      const blendRatio = Math.min(1, (now - showcaseResumeBlendStartedAt) / SHOWCASE_RESUME_BLEND_MS);
      setWaitingShowcasePosition(
        showcaseResumeBlendFrom + (targetPosition - showcaseResumeBlendFrom) * blendRatio
      );
      if (blendRatio >= 1) {
        showcaseResumeBlendStartedAt = null;
        showcaseManualResumeAt = 0;
      }
    } else {
      setWaitingShowcasePosition(targetPosition);
    }
    showcaseAnimationFrame = window.requestAnimationFrame(tickWaitingShowcase);
  }

  function displayWaitingCase(item, sequence) {
    if (!showcaseRunning || sequence !== showcaseLoadSequence) return;
    const wasVisible = !waitingShowcase.hidden;
    const applyCase = function() {
      if (!showcaseRunning || sequence !== showcaseLoadSequence) return;
      showcaseActiveCase = item;
      showcaseDragTracked = false;
      waitingBeforeImg.src = item.resolvedBeforeUrl;
      waitingAfterImg.src = item.resolvedAfterUrl;
      setWaitingShowcasePosition(reduceMotionQuery.matches ? 50 : 0);
      waitingShowcase.hidden = false;
      waitingShowcase.classList.remove("is-switching", "is-leaving");
      trackSpactifyEvent("spactify_showcase_view", {
        showcase_run_id: item.run_id
      });
      if (!reduceMotionQuery.matches) {
        showcaseCycleStartedAt = performance.now();
        showcaseManualResumeAt = 0;
        showcaseResumeBlendStartedAt = null;
        if (showcaseAnimationFrame) window.cancelAnimationFrame(showcaseAnimationFrame);
        showcaseAnimationFrame = window.requestAnimationFrame(tickWaitingShowcase);
      }
    };

    if (wasVisible) {
      waitingShowcase.classList.add("is-switching");
      window.setTimeout(applyCase, SHOWCASE_TRANSITION_MS);
    } else {
      applyCase();
    }
  }

  function showNextWaitingCase(attempt) {
    if (!showcaseRunning || !showcaseCases || !showcaseCases.length) return;
    const attempts = attempt || 0;
    if (attempts >= showcaseCases.length) {
      waitingShowcase.hidden = true;
      return;
    }
    const candidate = nextShowcaseCandidate();
    if (!candidate) return;
    const sequence = ++showcaseLoadSequence;
    preloadShowcaseCase(candidate)
      .then(function(item) {
        displayWaitingCase(item, sequence);
      })
      .catch(function() {
        if (!showcaseRunning || sequence !== showcaseLoadSequence) return;
        trackSpactifyEvent("spactify_showcase_load_failed", {
          showcase_run_id: candidate.run_id
        });
        showNextWaitingCase(attempts + 1);
      });
  }

  function startWaitingShowcase() {
    if (!waitingShowcase || showcaseRunning || !SHOWCASE_FEED_URL) return;
    showcaseRunning = true;
    showcaseQueue = [];
    showcaseQueueIndex = 0;
    if (showcaseCases) {
      if (showcaseCases.length) showNextWaitingCase();
      return;
    }
    fetch(SHOWCASE_FEED_URL, { credentials: "omit" })
      .then(function(response) {
        if (!response.ok) throw new Error(`showcase_feed_${response.status}`);
        return response.json();
      })
      .then(function(payload) {
        showcaseCases = Array.isArray(payload.items)
          ? payload.items.filter(function(item) {
              return item && item.run_id && item.before_url && item.after_url;
            })
          : [];
        showcaseQueue = [];
        showcaseQueueIndex = 0;
        if (showcaseRunning && showcaseCases.length) showNextWaitingCase();
      })
      .catch(function() {
        showcaseCases = [];
        waitingShowcase.hidden = true;
      });
  }

  function stopWaitingShowcase(fade) {
    showcaseRunning = false;
    showcaseLoadSequence += 1;
    showcasePointerActive = false;
    if (showcaseAnimationFrame) {
      window.cancelAnimationFrame(showcaseAnimationFrame);
      showcaseAnimationFrame = null;
    }
    if (!waitingShowcase) return;
    if (fade && !waitingShowcase.hidden) {
      waitingShowcase.classList.add("is-leaving");
      window.setTimeout(function() {
        if (!showcaseRunning) waitingShowcase.hidden = true;
      }, SHOWCASE_TRANSITION_MS);
    } else {
      waitingShowcase.hidden = true;
      waitingShowcase.classList.remove("is-switching", "is-leaving");
    }
  }

  function clearPolling() {
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
    if (pollRequestController) {
      pollRequestController.abort();
      pollRequestController = null;
    }
    pollConsecutiveFailures = 0;
  }

  function pausePollingForNavigation() {
    pollPausedForNavigation = true;
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
    if (pollRequestController) {
      pollRequestController.abort();
      pollRequestController = null;
    }
    if (showcaseAnimationFrame) {
      window.cancelAnimationFrame(showcaseAnimationFrame);
      showcaseAnimationFrame = null;
    }
  }

  function selectStyle(style) {
    const previousStyle = selectedStyle;
    selectedStyle = style;
    styleCards.forEach(function(card) {
      const selected = card.dataset.style === style;
      card.classList.toggle("is-selected", selected);
      card.setAttribute("aria-checked", selected ? "true" : "false");
    });
    if (previousStyle !== style) {
      clearPolling();
      stopWaitingShowcase(false);
      currentProgressIndex = 0;
      resetGenerationProgress();
      clearLifecycleState();
      isPreparing = false;
      isGenerating = false;
      outputSection.hidden = true;
      hideRecommendationPanel();
      resultPanel.hidden = true;
      progressPanel.hidden = true;
      if (previewProductsList) previewProductsList.innerHTML = "";
      if (previewProductCount) previewProductCount.textContent = "";
      if (recommendationAnalysis) recommendationAnalysis.textContent = "";
      productsList.innerHTML = "";
      productCount.textContent = "";
      resetResultDisplay();
      if (uploadedFile && currentUploadId) {
        persistLifecycleState({ status: "selected" });
      }
    }
    setGenerateState();
    trackSpactifyEvent("spactify_style_selected", {
      style: selectedStyle
    });
  }

  styleCards.forEach(function(card) {
    card.addEventListener("click", function() {
      selectStyle(card.dataset.style);
    });
  });

  dropZone.addEventListener("click", function(event) {
    if (event.target !== browseBtn && event.target !== removeImgBtn) {
      fileInput.click();
    }
  });

  dropZone.addEventListener("keydown", function(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      fileInput.click();
    }
  });

  browseBtn.addEventListener("click", function(event) {
    event.stopPropagation();
    fileInput.click();
  });

  fileInput.addEventListener("change", function() {
    if (fileInput.files.length > 0) {
      handleFile(fileInput.files[0]);
    }
  });

  dropZone.addEventListener("dragover", function(event) {
    event.preventDefault();
    dropZone.classList.add("is-dragging");
  });

  dropZone.addEventListener("dragleave", function() {
    dropZone.classList.remove("is-dragging");
  });

  dropZone.addEventListener("drop", function(event) {
    event.preventDefault();
    dropZone.classList.remove("is-dragging");
    if (event.dataTransfer.files.length > 0) {
      handleFile(event.dataTransfer.files[0]);
    }
  });

  removeImgBtn.addEventListener("click", function(event) {
    event.stopPropagation();
    resetUpload();
  });

  function releaseUploadedPreviewObjectUrl() {
    if (uploadedPreviewObjectUrl) {
      URL.revokeObjectURL(uploadedPreviewObjectUrl);
      uploadedPreviewObjectUrl = "";
    }
  }

  function showUploadedPreview(previewUrl, isObjectUrl) {
    releaseUploadedPreviewObjectUrl();
    uploadedPreviewUrl = previewUrl;
    if (isObjectUrl) {
      uploadedPreviewObjectUrl = previewUrl;
    }
    roomPreviewImg.src = previewUrl;
    uploadPlaceholder.hidden = true;
    previewContainer.hidden = false;
    dropZone.classList.add("has-image");
    setGenerateState();
    requestStageSync();
  }

  function restoreUploadedFile(savedState) {
    const uploadId = savedState && savedState.uploadId;
    if (!uploadId) return Promise.resolve(false);

    return getIndexedDbRecord("uploads", uploadId)
      .then(function(record) {
        if (!record || !record.blob) return false;

        const fileName = record.fileName || "room-image";
        const mimeType = record.mimeType || record.blob.type || "application/octet-stream";
        uploadedFile = new File([record.blob], fileName, {
          type: mimeType,
          lastModified: Number(record.lastModified || Date.now())
        });
        currentUploadId = uploadId;
        showUploadedPreview(URL.createObjectURL(record.blob), true);
        record.lastAccessedAt = Date.now();
        putIndexedDbRecord("uploads", record).catch(function(error) {
          console.warn("無法更新本地圖片使用時間。", error);
        });
        return true;
      })
      .catch(function(error) {
        console.warn("無法從 IndexedDB 恢復上傳圖片。", error);
        return false;
      });
  }

  function handleFile(file) {
    if (!file.type.match("image.*")) {
      trackSpactifyEvent("spactify_photo_rejected", {
        reason: "invalid_file_type",
        file_type: file.type || "unknown"
      });
      alert("請上傳有效的圖片檔案。");
      return;
    }

    const previousUploadId = currentUploadId;
    const previousRunId = currentRunId;
    uploadedFile = file;
    clearPolling();
    stopWaitingShowcase(false);
    currentProgressIndex = 0;
    resetGenerationProgress();
    isGenerating = false;
    isPreparing = false;
    uploadedPreviewUrl = "";
    releaseUploadedPreviewObjectUrl();
    clearLifecycleState();
    currentUploadId = createFlowId();
    currentRunId = createFlowId();
    outputSection.hidden = true;
    progressPanel.hidden = true;
    hideRecommendationPanel();
    resultPanel.hidden = true;
    if (previewProductsList) previewProductsList.innerHTML = "";
    if (previewProductCount) previewProductCount.textContent = "";
    if (recommendationAnalysis) recommendationAnalysis.textContent = "";
    productsList.innerHTML = "";
    productCount.textContent = "";
    generatedProducts = [];
    selectedCartVariantIds.clear();
    resetResultDisplay();

    if (previousUploadId && previousUploadId !== currentUploadId) {
      deleteIndexedDbRecord("uploads", previousUploadId).catch(function(error) {
        console.warn("無法清除舊的本地圖片。", error);
      });
    }
    if (previousRunId && previousRunId !== currentRunId) {
      deleteIndexedDbRecord("runs", previousRunId).catch(function(error) {
        console.warn("無法清除舊的本地任務。", error);
      });
    }

    persistLifecycleState({ status: "selected" });
    storeUploadedFile(file, currentUploadId).catch(function(error) {
      console.warn("無法將上傳圖片保存到 IndexedDB。", error);
    });

    const reader = new FileReader();
    reader.onload = function(event) {
      showUploadedPreview(event.target.result, false);
      persistLifecycleState({ status: "selected" });
      trackSpactifyEvent("spactify_photo_uploaded", {
        style: selectedStyle,
        file_type: file.type || "unknown",
        file_size_kb: Math.round((file.size || 0) / 1024)
      });
    };
    reader.readAsDataURL(file);
  }

  function resetUpload() {
    const uploadIdToDelete = currentUploadId;
    const runIdToDelete = currentRunId;
    uploadedFile = null;
    uploadedPreviewUrl = "";
    releaseUploadedPreviewObjectUrl();
    currentUploadId = "";
    currentRunId = createFlowId();
    fileInput.value = "";
    roomPreviewImg.src = "";
    uploadPlaceholder.hidden = false;
    previewContainer.hidden = true;
    dropZone.classList.remove("has-image");
    outputSection.hidden = true;
    progressPanel.hidden = true;
    hideRecommendationPanel();
    resultPanel.hidden = true;
    resetResultDisplay();
    if (previewProductsList) previewProductsList.innerHTML = "";
    if (previewProductCount) previewProductCount.textContent = "";
    if (recommendationAnalysis) recommendationAnalysis.textContent = "";
    productsList.innerHTML = "";
    productCount.textContent = "";
    generatedProducts = [];
    selectedCartVariantIds.clear();
    clearLifecycleState();
    clearPolling();
    stopWaitingShowcase(false);
    currentProgressIndex = 0;
    resetGenerationProgress();
    isPreparing = false;
    isGenerating = false;
    try {
      window.sessionStorage.removeItem("spactifyActiveRunId");
    } catch (error) {
      // Ignore storage cleanup failures.
    }
    deleteIndexedDbRecord("uploads", uploadIdToDelete).catch(function(error) {
      console.warn("無法刪除 IndexedDB 圖片。", error);
    });
    deleteIndexedDbRecord("runs", runIdToDelete).catch(function(error) {
      console.warn("無法刪除 IndexedDB 任務。", error);
    });
    setGenerateState();
  }

  function resolveProgressStage(stage) {
    let nextIndex = STAGE_ORDER.includes(stage) ? STAGE_ORDER.indexOf(stage) : 0;
    if (generatedProducts.length > 0) {
      nextIndex = Math.max(nextIndex, STAGE_ORDER.indexOf("recommending"));
    }
    if (isGenerating || activeGenerateStartedAt) {
      nextIndex = Math.max(nextIndex, STAGE_ORDER.indexOf("generating"));
    }
    nextIndex = Math.max(nextIndex, currentProgressIndex);
    return STAGE_ORDER[nextIndex] || "analyzing";
  }

  function updateProgress(stage) {
    const normalizedStage = resolveProgressStage(stage);
    const currentIndex = Math.max(STAGE_ORDER.indexOf(normalizedStage), 0);
    currentProgressIndex = currentIndex;
    progressSteps.forEach(function(step) {
      const stepIndex = STAGE_ORDER.indexOf(step.dataset.stage);
      step.classList.toggle("is-complete", stepIndex < currentIndex);
      step.classList.toggle("is-active", stepIndex === currentIndex);
    });

    progressPanel.dataset.stage = normalizedStage;

    if (normalizedStage === "generating") {
      startGenerationProgress();
    } else if (normalizedStage === "done") {
      completeGenerationProgress();
    } else {
      resetGenerationProgress();
      progressPanel.dataset.stage = normalizedStage;
    }
  }

  function showProgress(stage) {
    showResultShell(generatedProducts.length > 0);
    if (afterPanel) {
      afterPanel.hidden = true;
    }
    if (downloadRemodelBtn) {
      downloadRemodelBtn.hidden = true;
    }
    progressPanel.hidden = false;
    progressError.hidden = true;
    progressError.textContent = "";
    startWaitingShowcase();
    updateProgress(stage || "analyzing");
  }

  function showError(message) {
    clearGenerationProgressTimer();
    stopWaitingShowcase(true);
    progressError.textContent = message;
    progressError.hidden = false;
  }

  generateBtn.addEventListener("click", function() {
    startPrepareFlow();
  });

  if (generateFinalBtn) {
    generateFinalBtn.addEventListener("click", function() {
      startFinalGeneration();
    });
  }

  if (comparisonSlider) {
    comparisonSlider.addEventListener("input", function() {
      setComparisonPosition(comparisonSlider.value);
    });
  }

  if (waitingSlider) {
    const beginManualShowcaseControl = function() {
      if (!showcaseActiveCase) return;
      showcasePointerActive = true;
      showcaseManualResumeAt = 0;
      showcaseResumeBlendStartedAt = null;
      if (!showcaseDragTracked) {
        showcaseDragTracked = true;
        trackSpactifyEvent("spactify_showcase_drag", {
          showcase_run_id: showcaseActiveCase.run_id
        });
      }
    };
    const finishManualShowcaseControl = function() {
      if (!showcasePointerActive) return;
      showcasePointerActive = false;
      showcaseManualResumeAt = performance.now() + SHOWCASE_MANUAL_PAUSE_MS;
      showcaseResumeBlendStartedAt = null;
    };
    waitingSlider.addEventListener("pointerdown", beginManualShowcaseControl);
    waitingSlider.addEventListener("input", function() {
      if (!showcasePointerActive) beginManualShowcaseControl();
      setWaitingShowcasePosition(waitingSlider.value);
    });
    waitingSlider.addEventListener("change", finishManualShowcaseControl);
    window.addEventListener("pointerup", finishManualShowcaseControl);
    waitingSlider.addEventListener("blur", finishManualShowcaseControl);
  }

  reduceMotionQuery.addEventListener("change", function(event) {
    if (!showcaseRunning || !showcaseActiveCase) return;
    if (showcaseAnimationFrame) {
      window.cancelAnimationFrame(showcaseAnimationFrame);
      showcaseAnimationFrame = null;
    }
    if (event.matches) {
      setWaitingShowcasePosition(50);
      return;
    }
    setWaitingShowcasePosition(0);
    showcaseCycleStartedAt = performance.now();
    showcaseAnimationFrame = window.requestAnimationFrame(tickWaitingShowcase);
  });

  async function startPrepareFlow() {
    if (!uploadedFile || isPreparing || isGenerating) return;

    clearPolling();
    currentProgressIndex = 0;
    resetGenerationProgress();
    isPreparing = true;
    generatedProducts = [];
    selectedCartVariantIds.clear();
    preparedResult = null;
    currentCacheKey = "";
    currentTaskId = "";
    setGenerateState();
    showProgress("analyzing");
    trackSpactifyEvent("spactify_generate_click", {
      style: selectedStyle,
      file_type: uploadedFile.type || "unknown",
      file_size_kb: Math.round((uploadedFile.size || 0) / 1024)
    });

    const formData = new FormData();
    formData.append("image", uploadedFile);
    formData.append("style", selectedStyle);

    fetch(`${API_PREFIX}/api/prepare${window.location.search}`, {
      method: "POST",
      body: formData
    })
      .then(async function(response) {
        if (!response.ok) {
          let message = `伺服器回傳 ${response.status}`;
          try {
            const errorPayload = await response.json();
            if (errorPayload && errorPayload.detail) {
              message = errorPayload.detail;
            }
          } catch (parseError) {
            // Keep the status-based message when the response is not JSON.
          }
          throw new Error(message);
        }
        return response.json();
      })
      .then(function(data) {
        isPreparing = false;
        currentCacheKey = data.cache_key || "";
        currentTaskId = data.task_id || "";
        preparedResult = data;
        persistLifecycleState({
          cacheKey: currentCacheKey,
          taskId: currentTaskId,
          status: data.status
        });

        const hasPreparedProducts = Array.isArray(data.products) && data.products.length > 0;
        if (data.status === "success" && data.image_url) {
          renderResult(data);
        } else if (hasPreparedProducts) {
          if (data.status === "processing" && data.task_id) {
            isGenerating = true;
            activeGenerateStartedAt = Date.now();
            currentTaskId = data.task_id;
            renderRecommendationPreview(data).then(function() {
              showProgress(data.stage || "generating");
              pollGenerateStatus(data.task_id);
            });
          } else {
            renderRecommendationPreview(data).then(function() {
              startFinalGeneration();
            });
          }
        } else if (data.status === "processing" && data.task_id) {
          isGenerating = true;
          activeGenerateStartedAt = Date.now();
          showProgress(data.stage || "generating");
          pollGenerateStatus(data.task_id);
        } else {
          renderRecommendationPreview(data);
        }
        setGenerateState();
      })
      .catch(function(error) {
        console.error(error);
        isPreparing = false;
        setGenerateState();
        trackSpactifyEvent("spactify_generate_request_failed", {
          style: selectedStyle,
          error_type: error.name || "Error",
          duration_ms: 0
        });
        showError(`商品搭配失敗：${error.message}`);
      });
  }

  async function startFinalGeneration() {
    if (isGenerating || (!uploadedFile && !currentCacheKey)) return;

    clearPolling();
    resetGenerationProgress();
    isGenerating = true;
    activeGenerateStartedAt = Date.now();
    setGenerateState();
    showProgress("generating");
    trackSpactifyEvent("spactify_final_generate_click", {
      style: selectedStyle,
      cache_key_present: Boolean(currentCacheKey),
      product_count: generatedProducts.length,
      sku_list: buildSkuList(generatedProducts)
    });
    const gaIdentifiers = await getGaIdentifiers();

    const formData = new FormData();
    if (uploadedFile) {
      formData.append("image", uploadedFile);
    }
    if (currentCacheKey) {
      formData.append("cache_key", currentCacheKey);
    }
    formData.append("style", selectedStyle);
    formData.append("flow_id", currentFlowId);
    if (gaIdentifiers.clientId) {
      formData.append("ga_client_id", gaIdentifiers.clientId);
    }
    if (gaIdentifiers.sessionId) {
      formData.append("ga_session_id", gaIdentifiers.sessionId);
    }
    if (gaIdentifiers.sessionNumber) {
      formData.append("ga_session_number", gaIdentifiers.sessionNumber);
    }

    fetch(`${API_PREFIX}/api/generate${window.location.search}`, {
      method: "POST",
      body: formData
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error(`伺服器回傳 ${response.status}`);
        }
        return response.json();
      })
      .then(function(data) {
        if (!data.task_id) {
          throw new Error("伺服器未回傳任務編號。");
        }
        currentTaskId = data.task_id;
        currentCacheKey = data.cache_key || currentCacheKey;
        preparedResult = Object.assign({}, preparedResult || {}, {
          status: data.status || "processing",
          stage: "generating",
          cache_key: currentCacheKey,
          task_id: currentTaskId,
          products: generatedProducts
        });
        persistLifecycleState({
          cacheKey: currentCacheKey,
          taskId: currentTaskId,
          status: data.status || "processing"
        });
        pollGenerateStatus(data.task_id);
      })
      .catch(function(error) {
        console.error(error);
        const durationMs = activeGenerateStartedAt ? Date.now() - activeGenerateStartedAt : 0;
        isGenerating = false;
        activeGenerateStartedAt = null;
        setGenerateState();
        trackSpactifyEvent("spactify_generate_request_failed", {
          style: selectedStyle,
          error_type: error.name || "Error",
          duration_ms: durationMs
        });
        showError(`改造圖產生失敗：${error.message}`);
      });
  }

  function pollGenerateStatus(taskId) {
    const poll = function() {
      if (pollPausedForNavigation || document.visibilityState === "hidden" || pollRequestController) {
        return;
      }

      const controller = new AbortController();
      pollRequestController = controller;

      fetch(`${API_PREFIX}/api/generate-status/${taskId}${window.location.search}`, {
        signal: controller.signal
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error(`伺服器回傳 ${response.status}`);
          }
          return response.json();
        })
        .then(function(data) {
          pollConsecutiveFailures = 0;
          updateProgress(data.stage || "analyzing");

          if (data.status === "success") {
            clearPolling();
            updateProgress("done");
            currentCacheKey = data.cache_key || currentCacheKey;
            currentTaskId = taskId;
            persistLifecycleState({
              cacheKey: currentCacheKey,
              taskId: currentTaskId,
              status: "success"
            });
            renderResult(data);
            isGenerating = false;
            setGenerateState();
          } else if (data.status === "failed") {
            const durationMs = activeGenerateStartedAt ? Date.now() - activeGenerateStartedAt : 0;
            clearPolling();
            isGenerating = false;
            activeGenerateStartedAt = null;
            setGenerateState();
            persistLifecycleState({
              cacheKey: currentCacheKey,
              taskId: taskId,
              status: "failed"
            });
            trackSpactifyEvent("spactify_generate_failed", {
              style: selectedStyle,
              stage: data.stage || "unknown",
              error_type: "server_failed",
              duration_ms: durationMs
            });
            showError(data.detail || "改造圖產生失敗。");
          }
        })
        .catch(function(error) {
          const requestWasInterrupted = (
            controller.signal.aborted ||
            pollPausedForNavigation ||
            document.visibilityState === "hidden"
          );
          if (requestWasInterrupted) {
            return;
          }

          pollConsecutiveFailures += 1;
          if (pollConsecutiveFailures < 3) {
            console.warn("查詢產生狀態暫時失敗，將自動重試。", error);
            return;
          }

          const durationMs = activeGenerateStartedAt ? Date.now() - activeGenerateStartedAt : 0;
          clearPolling();
          isGenerating = false;
          activeGenerateStartedAt = null;
          setGenerateState();
          trackSpactifyEvent("spactify_generate_poll_failed", {
            style: selectedStyle,
            error_type: error.name || "Error",
            duration_ms: durationMs
          });
          showError(`查詢產生狀態失敗：${error.message}`);
        })
        .finally(function() {
          if (pollRequestController === controller) {
            pollRequestController = null;
          }
        });
    };

    clearPolling();
    pollPausedForNavigation = false;
    poll();
    pollTimer = setInterval(poll, 2500);
  }

  window.addEventListener("pagehide", pausePollingForNavigation);

  window.addEventListener("pageshow", function(event) {
    if (!event.persisted && !pollPausedForNavigation) return;

    pollPausedForNavigation = false;
    pollConsecutiveFailures = 0;
    if (showcaseRunning && showcaseActiveCase && !reduceMotionQuery.matches) {
      showcaseCycleStartedAt = performance.now();
      showcaseAnimationFrame = window.requestAnimationFrame(tickWaitingShowcase);
    }
    if (isGenerating && currentTaskId) {
      pollGenerateStatus(currentTaskId);
    } else {
      restoreCachedLifecycle();
    }
  });

  function resolveProduct(product) {
    if (product.variant_id || !product.handle) {
      return Promise.resolve(product);
    }

    return fetch(`/products/${encodeURIComponent(product.handle)}.js`)
      .then(function(response) {
        if (!response.ok) {
          throw new Error("無法取得產品資料。");
        }
        return response.json();
      })
      .then(function(shopifyProduct) {
        const variants = shopifyProduct.variants || [];
        const productSku = String(product.sku || product.product_id || "").toUpperCase();
        const matchingVariant = productSku
          ? variants.find(function(variant) {
              return String(variant.sku || "").toUpperCase() === productSku;
            })
          : null;
        const firstVariant = variants.length > 0 ? variants[0] : null;
        const selectedVariant = matchingVariant || firstVariant;
        const variantImage = selectedVariant && selectedVariant.featured_image
          ? selectedVariant.featured_image.src || selectedVariant.featured_image.url || selectedVariant.featured_image
          : "";
        const productImage = shopifyProduct.featured_image || (shopifyProduct.images && shopifyProduct.images[0]) || "";
        const shopifyPrice = selectedVariant && selectedVariant.price != null
          ? selectedVariant.price
          : shopifyProduct.price;
        const formattedPrice = shopifyPrice != null && !Number.isNaN(Number(shopifyPrice))
          ? (Number(shopifyPrice) / 100).toFixed(2)
          : product.price;
        return Object.assign({}, product, {
          title: product.title || shopifyProduct.title,
          price: formattedPrice,
          image_url: variantImage || productImage || product.image_url,
          variant_id: selectedVariant ? selectedVariant.id : product.variant_id
        });
      })
      .catch(function() {
        return product;
      });
  }

  function renderResult(data) {
    stopWaitingShowcase(true);
    currentCacheKey = data.cache_key || currentCacheKey;
    currentTaskId = data.task_id || currentTaskId;
    const imageUrl = withApiPrefix(data.image_url);
    if (data.output_width && data.output_height) {
      resultAfterImg.width = Number(data.output_width);
      resultAfterImg.height = Number(data.output_height);
    } else {
      resultAfterImg.removeAttribute("width");
      resultAfterImg.removeAttribute("height");
    }
    renderResultComparison(imageUrl);
    downloadRemodelBtn.href = imageUrl;

    Promise.all((data.products || []).map(resolveProduct)).then(function(products) {
      const durationMs = activeGenerateStartedAt ? Date.now() - activeGenerateStartedAt : 0;
      const items = buildAnalyticsItems(products);
      const value = calculateProductsValue(products);
      generatedProducts = products;
      preparedResult = Object.assign({}, data, { products: products, status: "success" });
      renderProducts(products);
      updateCartButtonState();
      progressPanel.hidden = true;
      hideRecommendationPanel();
      showResultShell(true);
      if (afterPanel) {
        afterPanel.hidden = false;
      }
      if (downloadRemodelBtn) {
        downloadRemodelBtn.hidden = false;
      }
      persistLifecycleState({
        cacheKey: currentCacheKey,
        taskId: currentTaskId,
        status: "success"
      });
      trackSpactifyEvent("spactify_result_view", {
        style: selectedStyle,
        duration_ms: durationMs,
        product_count: products.length,
        sku_list: buildSkuList(products)
      });
      trackSpactifyEvent("view_item_list", {
        item_list_id: "spactify_recommendations",
        item_list_name: "Spactify recommendations",
        currency: getStoreCurrency(),
        value: value,
        items: items
      });
      activeGenerateStartedAt = null;
    });
  }

  function renderRecommendationPreview(data) {
    return Promise.all((data.products || []).map(resolveProduct)).then(function(products) {
      generatedProducts = products;
      preparedResult = Object.assign({}, data, { products: products });
      if (recommendationAnalysis) {
        recommendationAnalysis.textContent = data.analysis || "";
      }
      renderProducts(products);
      updateCartButtonState();
      showResultShell(products.length > 0);
      if (afterPanel) {
        afterPanel.hidden = true;
      }
      if (downloadRemodelBtn) {
        downloadRemodelBtn.hidden = true;
      }
      progressPanel.hidden = false;
      updateProgress(data.stage || "generating");
      persistLifecycleState({
        cacheKey: currentCacheKey,
        taskId: currentTaskId,
        status: data.status || "prepared"
      });
      trackSpactifyEvent("spactify_recommendations_view", {
        style: selectedStyle,
        cache_hit: Boolean(data.cache_hit),
        product_count: products.length,
        sku_list: buildSkuList(products)
      });
      trackSpactifyEvent("view_item_list", {
        item_list_id: "spactify_recommendations",
        item_list_name: "Spactify recommendations",
        currency: getStoreCurrency(),
        value: calculateProductsValue(products),
        items: buildAnalyticsItems(products)
      });
      setGenerateState();
    });
  }

  function getProductUrl(product) {
    if (product.product_url) {
      return product.product_url;
    }
    if (product.handle) {
      return `/products/${encodeURIComponent(product.handle)}`;
    }
    return "";
  }

  function renderProducts(products) {
    renderProductCards(products, productsList, productCount);
  }

  function renderProductCards(products, listElement, countElement) {
    listElement.innerHTML = "";
    countElement.textContent = products.length ? `${products.length} 件商品` : "";

    if (!products.length) {
      const empty = document.createElement("p");
      empty.textContent = "目前沒有符合條件的推薦產品。";
      listElement.appendChild(empty);
      updateCartButtonState();
      return;
    }

    products.forEach(function(product) {
      const productUrl = getProductUrl(product);
      const cardShell = document.createElement("div");
      cardShell.className = "spactify-product-card-shell";
      const variantId = product.variant_id ? String(product.variant_id) : "";

      if (variantId) {
        cardShell.classList.add("is-selectable");
        const selectionLabel = document.createElement("label");
        selectionLabel.className = "spactify-product-selection";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = selectedCartVariantIds.has(variantId);
        checkbox.setAttribute(
          "aria-label",
          `選取 ${product.title || product.handle || "此商品"}`
        );
        checkbox.addEventListener("change", function() {
          if (checkbox.checked) {
            selectedCartVariantIds.add(variantId);
          } else {
            selectedCartVariantIds.delete(variantId);
          }
          cardShell.classList.toggle("is-selected", checkbox.checked);
          updateCartButtonState();
        });
        selectionLabel.appendChild(checkbox);
        cardShell.appendChild(selectionLabel);
        cardShell.classList.toggle("is-selected", checkbox.checked);
      }

      const card = document.createElement(productUrl ? "a" : "article");
      card.className = "spactify-product-card";
      if (productUrl) {
        card.href = productUrl;
        card.addEventListener("click", function() {
          persistLifecycleState({
            cacheKey: currentCacheKey,
            taskId: currentTaskId,
            status: preparedResult && preparedResult.status
          });
          trackSpactifyEvent("spactify_product_click", {
            style: selectedStyle,
            sku: product.sku || product.product_id || "",
            handle: product.handle || ""
          });
        });
      }

      const imageUrl = withApiPrefix(product.image_url);
      if (imageUrl) {
        const img = document.createElement("img");
        img.src = imageUrl;
        img.alt = product.title || product.handle || "推薦產品";
        img.width = 82;
        img.height = 82;
        card.appendChild(img);
      } else {
        const imageEmpty = document.createElement("div");
        imageEmpty.className = "spactify-product-image-empty";
        card.appendChild(imageEmpty);
      }

      const body = document.createElement("div");
      const title = document.createElement("h3");
      title.textContent = product.title || product.handle || "推薦產品";
      body.appendChild(title);

      const metaParts = [product.sku, product.size_label].filter(Boolean);
      if (metaParts.length) {
        const meta = document.createElement("p");
        meta.className = "spactify-product-meta";
        meta.textContent = metaParts.join(" · ");
        body.appendChild(meta);
      }

      if (product.price) {
        const price = document.createElement("span");
        price.className = "spactify-product-price";
        price.textContent = `$${product.price}`;
        body.appendChild(price);
      }

      card.appendChild(body);
      cardShell.appendChild(card);

      listElement.appendChild(cardShell);
    });

    updateCartButtonState();
  }

  function applyRestoredStyle(style) {
    if (!style) return;
    selectedStyle = style;
    styleCards.forEach(function(card) {
      const selected = card.dataset.style === style;
      card.classList.toggle("is-selected", selected);
      card.setAttribute("aria-checked", selected ? "true" : "false");
    });
  }

  function restoreLocalLifecycle(savedState) {
    const snapshot = savedState.snapshot;
    const storedProducts = snapshot && Array.isArray(snapshot.products)
      ? snapshot.products
      : Array.isArray(savedState.products)
        ? savedState.products
        : [];

    applyRestoredStyle((snapshot && snapshot.style) || savedState.style);
    currentCacheKey = (snapshot && snapshot.cache_key) || savedState.cacheKey || "";
    currentTaskId = (snapshot && snapshot.task_id) || savedState.taskId || "";

    if (savedState.status === "success" && snapshot && snapshot.image_url) {
      preparedResult = Object.assign({}, snapshot, { status: "success", products: storedProducts });
      renderResult(preparedResult);
      setGenerateState();
      return true;
    }

    if (savedState.status === "processing" && currentTaskId && (snapshot || storedProducts.length)) {
      const processingState = Object.assign({}, snapshot || {}, {
        status: "processing",
        stage: (snapshot && snapshot.stage) || "generating",
        cache_key: currentCacheKey,
        task_id: currentTaskId,
        products: storedProducts
      });
      preparedResult = processingState;
      isGenerating = true;
      activeGenerateStartedAt = Date.now();
      if (storedProducts.length) {
        renderRecommendationPreview(processingState).then(function() {
          showProgress(processingState.stage);
          pollGenerateStatus(currentTaskId);
        });
      } else {
        showProgress(processingState.stage);
        pollGenerateStatus(currentTaskId);
      }
      setGenerateState();
      return true;
    }

    return false;
  }

  function resumeStoredTask(savedState) {
    applyRestoredStyle(savedState.style);
    currentCacheKey = savedState.cacheKey || "";
    currentTaskId = savedState.taskId || "";
    if (!currentTaskId || !["processing", "success"].includes(savedState.status)) return;

    isGenerating = true;
    activeGenerateStartedAt = Date.now();
    showProgress("generating");
    setGenerateState();
    pollGenerateStatus(currentTaskId);
  }

  async function restoreCachedLifecycle() {
    let savedState = getStoredLifecycleState();
    if (!savedState) {
      let activeRunId = "";
      try {
        activeRunId = window.sessionStorage.getItem("spactifyActiveRunId") || "";
      } catch (error) {
        activeRunId = "";
      }
      if (activeRunId) {
        try {
          savedState = await getIndexedDbRecord("runs", activeRunId);
        } catch (error) {
          console.warn("無法從 IndexedDB 取得任務快照。", error);
        }
      }
    }

    if (!savedState || (!savedState.uploadId && !savedState.cacheKey && !savedState.taskId)) {
      return;
    }

    currentRunId = savedState.runId || savedState.id || currentRunId;
    currentUploadId = savedState.uploadId || "";
    await restoreUploadedFile(savedState);
    setGenerateState();

    if (!savedState.cacheKey && !savedState.taskId) {
      return;
    }

    if (restoreLocalLifecycle(savedState)) {
      return;
    }

    fetch(`${API_PREFIX}/api/session-state${window.location.search}`)
      .then(function(response) {
        if (!response.ok) {
          throw new Error(`伺服器回傳 ${response.status}`);
        }
        return response.json();
      })
      .then(function(state) {
        const entries = state.entries || [];
        const restored = entries.find(function(entry) {
          return (
            (savedState.cacheKey && entry.cache_key === savedState.cacheKey) ||
            (savedState.taskId && entry.task_id === savedState.taskId)
          );
        }) || state.latest;

        if (!restored) {
          resumeStoredTask(savedState);
          return;
        }

        applyRestoredStyle(restored.style || savedState.style);
        currentCacheKey = restored.cache_key || savedState.cacheKey || "";
        currentTaskId = restored.task_id || savedState.taskId || "";
        preparedResult = restored;

        const hasRestoredProducts = Array.isArray(restored.products) && restored.products.length > 0;
        if (restored.status === "processing" && currentTaskId && hasRestoredProducts) {
          isGenerating = true;
          activeGenerateStartedAt = Date.now();
          renderRecommendationPreview(restored).then(function() {
            showProgress(restored.stage || "generating");
            pollGenerateStatus(currentTaskId);
          });
        } else if (restored.status === "processing" && currentTaskId) {
          isGenerating = true;
          activeGenerateStartedAt = Date.now();
          showProgress(restored.stage || "generating");
          pollGenerateStatus(currentTaskId);
        } else if (restored.status === "success" && restored.image_url) {
          renderResult(restored);
        } else if (restored.products && restored.products.length) {
          renderRecommendationPreview(restored);
        }
        setGenerateState();
      })
      .catch(function(error) {
        console.warn("無法取得伺服器工作階段，改用本地任務狀態恢復。", error);
        resumeStoredTask(savedState);
      });
  }

  function addProductsToCart(products, loadingButtons) {
    const cartProducts = products.filter(function(product) {
      return product.variant_id;
    });
    const items = cartProducts
      .map(function(product) {
        return {
          id: parseInt(product.variant_id, 10),
          quantity: 1
        };
      });

    if (!items.length) {
      trackSpactifyEvent("spactify_cart_add_failed", {
        reason: "no_variant",
        product_count: generatedProducts.length,
        sku_list: buildSkuList(generatedProducts)
      });
      alert("目前沒有可加入購物車的產品。");
      return;
    }

    loadingButtons.forEach(function(button) {
      button.disabled = true;
      button.dataset.loading = "true";
      button.setAttribute("aria-busy", "true");
      button.textContent = "加入中...";
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error("無法加入購物車。");
        }
        return response.json();
      })
      .then(function() {
        const analyticsItems = buildAnalyticsItems(cartProducts);
        trackSpactifyEvent("add_to_cart", {
          currency: getStoreCurrency(),
          value: calculateProductsValue(cartProducts),
          product_count: cartProducts.length,
          sku_list: buildSkuList(cartProducts),
          items: analyticsItems
        }, { waitForCallback: true, eventTimeout: 800 }).finally(function() {
          window.setTimeout(function() {
            window.location.href = "/cart";
          }, 50);
        });
      })
      .catch(function(error) {
        console.error(error);
        loadingButtons.forEach(function(button) {
          button.dataset.loading = "false";
          button.disabled = false;
          button.removeAttribute("aria-busy");
        });
        updateCartButtonState();
        trackSpactifyEvent("spactify_cart_add_failed", {
          reason: "cart_api_error",
          error_type: error.name || "Error",
          product_count: cartProducts.length,
          sku_list: buildSkuList(cartProducts)
        });
        alert(`加入購物車失敗：${error.message}`);
      });
  }

  function handleAddToCartClick() {
    const selectedProducts = generatedProducts.filter(function(product) {
      return product.variant_id && selectedCartVariantIds.has(String(product.variant_id));
    });
    addProductsToCart(
      selectedProducts.length ? selectedProducts : generatedProducts,
      addToCartButtons
    );
  }

  addToCartButtons.forEach(function(button) {
    button.addEventListener("click", handleAddToCartClick);
  });

  trackSpactifyEvent("spactify_page_view", {
    style: selectedStyle
  });
  setGenerateState();
  restoreCachedLifecycle();
});
